export interface IAddComment {
    OrderId?: Guid;
    Comment: string;
}

export class AddComment implements IAddComment {
    OrderId: Guid = null;
    Comment: string = "";

    constructor(OrderId: Guid, Comment: string) {
        this.OrderId = OrderId;
        this.Comment = Comment;
    }
}